import { ReactElement } from 'react'

import Image from 'next/image'

import { Link } from '@/i18n/navigation'

import { generateImagePlaceHolder } from '@/lib/utils'

import styles from './styles.module.scss'

interface Props {
    title: string
    coverImage: string | null
    link: string
    excerpt: string
}

export default function ArticleBigItem({
    title,
    coverImage,
    link,
    excerpt,
}: Props): ReactElement {
    return (
        <Link href={link} className={styles.link}>
            <div className={styles.link__item}>
                <div className={styles.link__info}>
                    <h3>{title}</h3>
                    <p>{excerpt}</p>
                    {/*<span>{updatedAt}</span>*/}
                </div>
            </div>
            <div className={styles.link__item}>
                <Image
                    width={500}
                    height={500}
                    src={coverImage!}
                    alt={title}
                    className={styles.link__image}
                    draggable={false}
                    quality={100}
                    placeholder={generateImagePlaceHolder(500, 500)}
                />
            </div>
        </Link>
    )
}
